import getAttachment from '../selectors/getAttachment';
import AttachmentInfo from '../store/schema/AttachmentInfo';
import { ClientAttachmentId } from 'owa-client-ids';
import { action } from 'satcheljs/lib/legacy';

export default action('setAttachmentInfo')(function setAttachmentInfo(
    attachmentId: ClientAttachmentId,
    attachmentInfo: AttachmentInfo
) {
    const attachment = getAttachment(attachmentId);
    attachment.info = attachmentInfo;
});
